import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ProdutividadePorTurnoGrafico } from 'app/interfaces/Turno';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-produtividade-turnos',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './produtividade-turnos.component.html',
  styleUrl: './produtividade-turnos.component.css'
})
export class ProdutividadeTurnosComponent implements OnInit {
  public readonly Math = Math;
  
  @Input() turnosData: ProdutividadePorTurnoGrafico[] = [];
  
  get turnos(): ProdutividadePorTurnoGrafico[] {
    return this.turnosData || [];
  }

  public formatarValor(valor: number): string {
    if (valor === undefined || valor === null) return '0';
    
    if (Number.isInteger(valor)) {
      return valor.toString();
    }
    
    return valor.toFixed(2);
  }
  
  get hasScrollableTurnos(): boolean {
    return (this.turnos?.length || 0) > 3;
  }

  constructor() {}

  ngOnInit(): void {}
}
